import { isLocalDealerManager, isLocalMarketManagerWithManagedMarketplaces } from "@slfinrtl/ppn-roles"
import { exportDisclaimerMessages } from "@slfinrtl/ui-bff-routes"
import { useIntl } from "react-intl"
import { getJwtPayload } from "src/common/jwt/jwtUtils"

export const useExportDisclaimerText = () => {
	const { formatMessage } = useIntl()
	const jwtClaims = getJwtPayload()
	const groups = jwtClaims?.["ppn:groups"] ?? ""
	return jwtClaims && isLocalMarketManagerWithManagedMarketplaces(jwtClaims)
		? formatMessage(exportDisclaimerMessages.localMarketManagerDisclaimer)
		: isLocalDealerManager(groups)
			? formatMessage(exportDisclaimerMessages.localDealerManagerDisclaimer)
			: formatMessage(exportDisclaimerMessages.defaultDisclaimer)
}
